import type { TranslateFn } from "#/lib/i18n.js";
import { BrandLogo, ChromeNav, getLocalizedHref } from "./shared.js";

export function HeaderBentoConsole({ locale, t }: { locale: string; t: TranslateFn }) {
  return (
    <header
      data-public-chrome="header"
      className="sticky top-0 z-40 border-b border-[color:var(--color-border-subtle)] bg-[color:var(--color-bg-base)]"
    >
      <div className="mx-auto flex max-w-[96rem] flex-col gap-2 px-4 py-2 sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8">
        <BrandLogo href={getLocalizedHref(locale, "/")} t={t} size="sm" />
        <div className="flex min-w-0 flex-wrap items-center gap-2">
          <span className="inline-flex min-h-11 items-center rounded-md border border-[color:var(--color-border-subtle)] px-3 font-mono text-xs text-[color:var(--color-fg-muted)]">
            {t("chrome.nav.activeOutbreaks")}
          </span>
          <ChromeNav locale={locale} t={t} compact />
        </div>
      </div>
    </header>
  );
}
